import React from "react";

const ImageBlock = ({ data, update, mode }) => {
  if (mode === "edit") {
    return (
      <input
        className="form-control"
        placeholder="Paste image URL..."
        value={data.url}
        onChange={(e) => update({ url: e.target.value })}
      />
    );
  }

  return data.url ? (
    <img src={data.url} alt="" className="img-fluid rounded shadow-sm" />
  ) : (
    <p className="text-muted fst-italic">No image</p>
  );
};

export default ImageBlock;